export const EXTRA_CONSUMPTION_LIMIT_EL = 100_000
export const EXTRA_CONSUMPTION_LIMIT_GAS = 10_000

export const NEVER_SHOW_INSTALMENT_INFO_MODAL = 'neverShowInstalmentInfoModal'
export const HIDE_INACCURACY_WARNING = 'hideInaccuracyWarning'
